export default __webpack_public_path__ + "static/media/_logo_card_visa.460543cf.svg";